// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountAdmin } from './account-admin';
import { AccountUser } from './account-user';
import { JobOrder } from './job-order';
import { ProgramAllowance } from './program-allowance';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags
/** Note stamped on the credit that offsets a global-allowance draw at order placement.
 *  job-order-placement.service.ts writes it and logTrx below reads it — keep them in step. */
export const COVERED_BY_GLOBAL_ALLOWANCE_NOTE = 'Covered by global allowance';
/// </module-code>

export class ProgramAllowanceUserLog extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get logType(): string {
    return 'PROGRAM';
  }

  get logTrx(): string {
    if (this.jobOrderId == null) {
      if (this.amt < 0) {
        return 'Adj. to (+) Increase Your Program Allowance';
      } else {
        return 'Adj. to (-) Reduce Your Program Allowance';
      }
    } else {
      if (this.amt < 0) {
        // Not a refund: the order overran this allowance and the user's global allowance paid the
        // difference. Without this credit the overrun would be charged twice — once inside the
        // order's full charge above, once again in AccountUserAllowanceLog.
        if (this.adjustmentNote === COVERED_BY_GLOBAL_ALLOWANCE_NOTE) {
          return 'Covered by Global Allowance';
        }
        return 'Credit / Refund';
      } else {
        return 'Allowance Charged Against Order';
      }
    }
  }

  get debit(): number {
    return this.amt > 0 ? this.amt : 0;
    /*     if (this.jobOrderId != null) {
      return this.amt;
    } else {
      if (this.amt > 0) {
        return this.amt;
      } else {
        return 0;
      }
    } */
  }

  get credit(): number {
    return this.amt < 0 ? -this.amt : 0;
    /*     if (this.jobOrderId == null) {
      if (this.amt < 0) {
        return -this.amt;
      } else {
        return 0;
      }
    } else {
      return 0;
    } */
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK accountAdmin */
  accountAdminId?: string;
  /** Guid FK accountUser */
  accountUserId!: string;
  /** String(2000) */
  adjustmentNote?: string;
  /** Decimal */
  amt!: number;
  /** Guid FK jobOrder */
  jobOrderId?: string;
  /** DateTimeOffset */
  logTs!: Date;
  /** Guid FK programAllowance */
  programAllowanceId!: string;
  /** Guid */
  sourceDetailId?: string;
  /** FK accountAdminId */
  accountAdmin!: AccountAdmin;
  /** FK accountUserId */
  accountUser!: AccountUser;
  /** FK jobOrderId */
  jobOrder!: JobOrder;
  /** FK programAllowanceId */
  programAllowance!: ProgramAllowance;
}

